import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { MachineConfigUIProductionTypeEnum } from '@clean-code/types/config';

export const getHighlightedStopSelector = (store: any): any =>
  store.machines.highlightedStop;

export const getMachinesSelector = (store: RootState): any =>
  store.machines.machines;

export const getMachinesLoadingSelector = (store: RootState): boolean =>
  store.machines.isMachinesListLoading;

export const getMachinesSelectorBase = createSelector(
  [getMachinesSelector],
  (machinesState) => {
    return machinesState;
  }
);

export const makeGetMachineByIdSelector = (machineId: number) =>
  createSelector(
    [getMachinesSelectorBase],
    (
      machines
    ): {
      hasTotalOrCorrectType: boolean;
      hasDefectsType: boolean;
      defaultProductionAdvancementType?: 'total' | 'correct';
      countSensors: MachineConfigUIProductionTypeEnum[];
    } => {
      return machines?.find((machine) => machine.id === machineId);
    }
  );
